import { render, staticRenderFns } from "./TableOldStock.vue?vue&type=template&id=0b3a76c4&scoped=true&"
import script from "./TableOldStock.vue?vue&type=script&lang=js&"
export * from "./TableOldStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a76c4",
  null
  
)

export default component.exports